import { Component, Input, OnInit } from '@angular/core';
import { ETNotification } from '@src/app/models/ETnotification';
import { NotificationitemService } from './service/notificationitem.service';
import { Router } from '@angular/router';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { NotificationStateService } from '@src/app/helpers/notification-state.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-notificationitem',
  templateUrl: './notificationitem.component.html',
  styleUrls: ['./notificationitem.component.css']
})
export class NotificationitemComponent implements OnInit {
  @Input() notification:ETNotification;
  @Input() newmsg:boolean;
  private hoverReadDelayMs = 800;
  private hoverReadTimeoutId: number | null = null;

  constructor(
    private nisrv:NotificationitemService, 
    private router: Router,
    private uieventhub:UieventhubService,
    private datastore: DatastoreService,
    private notificationState: NotificationStateService
  ) { }

  ngOnInit(): void {
    this.newmsg = this.notification.dateread == "9999-01-01T00:00:00.000Z";
  }

  scheduleMarkAsRead(): void {
    if (this.hoverReadTimeoutId !== null || this.notification.dateread != this.notificationState.unreadSentinel) {
      return;
    }

    this.hoverReadTimeoutId = window.setTimeout(() => {
      this.hoverReadTimeoutId = null;
      this.markAsRead();
    }, this.hoverReadDelayMs);
  }

  cancelScheduledMarkAsRead(): void {
    if (this.hoverReadTimeoutId === null) {
      return;
    }

    window.clearTimeout(this.hoverReadTimeoutId);
    this.hoverReadTimeoutId = null;
  }

  markAsRead(): void {
    this.cancelScheduledMarkAsRead();

    if(this.notification.dateread == this.notificationState.unreadSentinel){
      this.newmsg = false;
      const currentNotifications = this.datastore.notifications.getValue() || [];
      const nextNotifications = this.notificationState.applyRead(currentNotifications, this.notification, SessionHelper.getChoosenOrg());
      this.datastore.notifications.next(nextNotifications);
      this.notificationState.setSessionUnreadCount(nextNotifications);
      this.notification = {
        ...this.notification,
        organization: SessionHelper.getChoosenOrg(),
        dateread: new Date().toISOString(),
      };
      this.nisrv.markRead(this.notification).pipe(untilDestroyed(this)).subscribe(readdate =>{
        const syncedNotifications = this.notificationState.mergeNotification(this.datastore.notifications.getValue() || [], readdate);
        this.datastore.notifications.next(syncedNotifications);
        this.notificationState.setSessionUnreadCount(syncedNotifications);
        this.notification = readdate;
      }
      , _error => {
        this.datastore.notifications.next(currentNotifications);
        this.notificationState.setSessionUnreadCount(currentNotifications);
      }
      );
    }
  }
  // navigate(link:string){
  //   //if the notification link is a project, set the current project
  //   if(link.includes('project')){
  //     let projectId =link.substring(link.indexOf('project')+8);
  //     //console.log('projectId',projectId);
  //     this.uieventhub.setCurrentProject(projectId);
  //     SessionHelper.setCurrentProject(projectId);
  //   }
  //  // this.uieventhub.setCurrentProject(project.projectId);
  //   // SessionHelper.setCurrentProject(project.projectId);
  //   // SessionHelper.setCurrentProjectName(project.title);
  //   // SessionHelper.setCurrentProjectFull(JSON.stringify(project));
  //   let path = link.substring(link.indexOf(link.split('/')[3]));
  //   //console.log('path',path);
  //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
  //     this.router.navigate(['/'+path]);
  //   });
   
  //   //this.router.navigateByUrl(link.substr(link.indexOf(link.split('/')[3])));
  // }
  navigate(link: string): void {
    this.markAsRead();

    // Extract projectId safely (ignores query/hash)
    const url = new URL(link, window.location.origin);
    const projectSeg = url.pathname.split('/').find(s => s.startsWith('project_'));
    if (projectSeg) {
      const projectId = projectSeg.replace(/^project_/, '');
      this.uieventhub.setCurrentProject(projectId);
      SessionHelper.setCurrentProject(projectId);
    }

    // Parse full URL (path + query + hash) and navigate
    const tree = this.router.parseUrl(url.pathname + url.search + url.hash);
    this.router.navigateByUrl(tree); // keeps ?token=... intact
  }
}
